import React, { useEffect, useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import ScratchCardDisplay from './ScratchCardDisplay';

/**
 * ScratchCardsDisplay Component
 * 
 * Displays the 4 scratch card options in a horizontal scrollable layout
 */
const ScratchCardsDisplay = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoaded, setIsLoaded] = useState(false);
  
  // Use useEffect to ensure the component is properly loaded
  useEffect(() => {
    console.log('ScratchCardsDisplay mounted, current path:', location.pathname);
    setIsLoaded(true);
  }, [location.pathname]);

  const handleCardSelect = (cardId) => {
    console.log('Selecting card:', cardId);
    
    // Use React Router's navigate for consistent routing
    navigate(`/modular-profile/games/scratch-cards/${cardId}`);
  };

  return (
    <Box width="100%">
      <Box 
        width="100%" 
        overflowX="auto" 
        pb={4}
        css={{
          '&::-webkit-scrollbar': {
            height: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'rgba(0,0,0,0.1)',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(255,255,255,0.2)',
            borderRadius: '4px',
          },
          // Add horizontal scrolling indicator
          '&::after': {
            content: '"→"',
            position: 'absolute',
            right: '10px',
            bottom: '0',
            color: 'rgba(255,255,255,0.5)',
            fontSize: '20px',
            animation: 'fadeInOut 1.5s infinite',
          },
        }}
      >
        <Flex alignItems="center" justifyContent="flex-start" gap="15px" overflowX="auto" pb={4}>
          {/* QUICK CASH CARD */}
          <Box 
            width="31%"
            mr={"2%"}
            flexShrink={0}
            onClick={() => handleCardSelect('quick_cash')}
            cursor="pointer"
            transition="transform 0.3s"
            _hover={{ transform: 'scale(1.02)' }}
          >
            <ScratchCardDisplay 
              cardType="quick_cash"
              isPreview={true}
              onPlay={() => handleCardSelect('quick_cash')}
            />
          </Box>
          
          {/* CASH KING CARD */}
          <Box 
            width="31%"
            mr={"2%"}
            flexShrink={0}
            onClick={() => handleCardSelect('cash_king')}
            cursor="pointer"
            transition="transform 0.3s"
            _hover={{ transform: 'scale(1.02)' }}
          >
            <ScratchCardDisplay 
              cardType="cash_king"
              isPreview={true}
              onPlay={() => handleCardSelect('cash_king')}
            />
          </Box>
          
          {/* JACKPOT MILLIONS CARD */}
          <Box 
            width="31%"
            mr={"2%"}
            flexShrink={0}
            onClick={() => handleCardSelect('jackpot_millions')}
            cursor="pointer"
            transition="transform 0.3s"
            _hover={{ transform: 'scale(1.02)' }}
          >
            <ScratchCardDisplay 
              cardType="jackpot_millions"
              isPreview={true}
              onPlay={() => handleCardSelect('jackpot_millions')}
            />
          </Box>
          
          {/* MEGA MILLIONS CARD */}
          <Box 
            width="31%"
            flexShrink={0}
            onClick={() => handleCardSelect('mega_millions')}
            cursor="pointer"
            transition="transform 0.3s"
            _hover={{ transform: 'scale(1.02)' }}
          >
            <ScratchCardDisplay 
              cardType="mega_millions"
              isPreview={true}
              onPlay={() => handleCardSelect('mega_millions')}
            />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default ScratchCardsDisplay;
